import React, { useEffect, useState } from "react";
import Style from "../Style/Gallery.module.scss";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";

const baseURL = process.env.REACT_APP_BASE_URL;

const Gallery = ({ darkMode }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const fetchGalleryImages = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/images`);
      console.log("API Response:", res.data);

      let imageArray = [];
      if (Array.isArray(res.data)) {
        imageArray = res.data;
      } else if (res.data?.images && Array.isArray(res.data.images)) {
        imageArray = res.data.images;
      }

      setImages(imageArray);
      if (imageArray.length === 0) {
        setError("No images available.");
      }
    } catch (err) {
      console.error("Error fetching images:", err);
      setError("Failed to load images.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <link rel="canonical" href="gallery" />
        </Helmet>
      </HelmetProvider>

      <div className={`${Style.Gallery} ${darkMode ? Style.dark : ""}`}>
        <div className={Style.wrapper}>
          <div className={Style.GalleryDisk}>
            <h4>Our Gallery</h4>
            <p>Explore some moments from our educational activities.</p>
          </div>

          {loading ? (
            <p style={{ textAlign: "center", width: "100%" }}>Loading...</p>
          ) : error ? (
            <p style={{ textAlign: "center", width: "100%" }}>{error}</p>
          ) : (
            <div className={Style.GalleryFlex}>
              {images.slice(0, 6).map((img) => (
                <div className={Style.GalleryWrap} key={img.id}>
                  <img
                    src={img.image_url}
                    alt={`Gallery image ${img.id}`}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Gallery;
